import React, { useEffect } from 'react';
import { Grid, MenuItem } from '@material-ui/core';
import { ISubtaskItemDurationFilter } from '../../../../../state/report';
import {
  IFilterContainerConfigProps,
  FilterContainer,
} from '../../../../components/FilterContainer';
import {
  SearchDropdownField,
  SearchField,
  SearchDateField,
} from '../../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../state/configureStore';
import {
  fetchAllSubtaskTypeList,
  SubtaskTypeState,
} from '../../../../../state/subtaskType';

const SubtaskItemWorkDurationFilterComponent: React.FC<
  IFilterContainerConfigProps<ISubtaskItemDurationFilter>
> = props => {
  const dispatch = useDispatch();
  const { items: subtaskTypeList } = useSelector<AppState, SubtaskTypeState>(
    state => state.subtaskType,
  );

  useEffect(() => {
    dispatch(fetchAllSubtaskTypeList());
  }, [dispatch]);

  return (
    <FilterContainer
      {...props}
      render={filterProps => {
        const { localFilter, handleChangeFilter, handleChangeDateFilter } = filterProps;
        return (
          <Grid container spacing={1}>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Task Number"
                filterKey="SmSubtaskItem.SmSubtask.SMTask.TaskNumber.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Program"
                filterKey="SmSubtaskItem.SmTaskItem.OpportunityItem.Block.Program.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Brand"
                filterKey="SmSubtaskItem.SmTaskItem.OpportunityItem.Block.Brand.Name.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Block No"
                filterKey="SmSubtaskItem.SmTaskItem.OpportunityItem.Block.BlockNo.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Subject"
                filterKey="SmSubtaskItem.SmSubtask.Subject.Contains"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Requester"
                filterKey="SmSubtaskItem.SmSubtask.SMTask.Requester.FullNameWithUserName.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchField
                fullWidth={true}
                label="Assignee"
                filterKey="SmSubtask.SmSubtaskAssignees.User.FullNameWithUserName.StartsWith"
                onChange={handleChangeFilter}
                filters={localFilter}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDropdownField
                id={'subtask-type-filter'}
                label={'Type'}
                onChange={handleChangeFilter}
                filters={localFilter}
                filterKey={'SmSubtaskItem.SmSubtask.SmSubTaskType.Code.EqualsTo'}
              >
                <MenuItem value="">All</MenuItem>
                {subtaskTypeList.map(subtaskType => {
                  return (
                    <MenuItem key={subtaskType.id} value={subtaskType.code}>
                      {subtaskType.name}
                    </MenuItem>
                  );
                })}
              </SearchDropdownField>
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDateField
                showTodayButton={true}
                fullWidth={true}
                label="Start Date"
                onChange={handleChangeDateFilter}
                filters={localFilter}
                filterKey={'StartDate.GreaterThanOrEqual'}
              />
            </Grid>
            <Grid item xs={12} md={3} lg={2}>
              <SearchDateField
                showTodayButton={true}
                fullWidth={true}
                label="End Date"
                onChange={handleChangeDateFilter}
                filters={localFilter}
                filterKey={'EndDate.LessThanOrEqual'}
              />
            </Grid>
          </Grid>
        );
      }}
    />
  );
};

export default SubtaskItemWorkDurationFilterComponent;
